import springCenfApi from '../../services/springCenfApi'

export const getActivityLogs = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/activity_logs', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)